export const environment = {
  production: true,
  enableSentry: false,
  enableAdminTool: true,
  enableServiceWorker: true,
  capchaSiteKey: '6LfSPAgsAAAAAIgwmgIPrBp9N9HoZHCTusg0F4z5',
  capchav2SiteKey: '6LcMthYUAAAAADi-mVvawXjecfy0lY7AmbiX-C56',	
  baseUrl: 'https://development.marcorubber.com',
  API_URL: 'https://development.marcorubber.com/api/pricing',
  CUSTOMERS_API_URL: 'https://development.marcorubber.com/api/customer',
  INTEGRATION_API_URL: 'https://development.marcorubber.com/api/integration',
  SOLUPAY_TOKENIZATION_KEY: '28w2vu-SqpDUr-97r886-YzAUE6',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_51TJe0AQom6S4SFhi1FjZfCE0o4Gs80lP4UDHPys0PpBiWsnoBSaPf4fheADZJa1FPfqS9TWxT7TDeGxilZvo8vEd00fXABRFip',
  VERSION: '1.0.12',
  environment: 'development',
  enableDrift: true
};